import { render, staticRenderFns } from "./VmcCrewFamilyParty2024IloiloBacolod.vue?vue&type=template&id=7a869f30&scoped=true"
import script from "./VmcCrewFamilyParty2024IloiloBacolod.vue?vue&type=script&lang=js"
export * from "./VmcCrewFamilyParty2024IloiloBacolod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a869f30",
  null
  
)

export default component.exports